module.exports = __webpack_public_path__ + "static/media/dice-two.50ed0b58.svg";